import {CustomerId} from "./Customer";
import {Contact} from "../common/Contact";
import {Module} from "../common/Module";
import {isPrivileged} from "../../config/Privileges";
import {CUSTOMER_AREA_NAME} from "./CustomerModule";

export const CustomerContactModule: Module = {
    identifier: 'customer_contacts',
    isPrivileged: ( authUser, privilege ) =>
        isPrivileged(
            authUser,
            CUSTOMER_AREA_NAME,
            CustomerContactModule.identifier,
            privilege
        ),
};

export interface CustomerContact extends CustomerId, Contact {

}

export type CustomerContactProp = {
    customerContact: CustomerContact
}